export default __webpack_public_path__ + "static/media/free_bag.58dbc964.png";